import { Link } from 'react-router-dom';
import { useState } from 'react';
import { footerLinks } from '@/mocks/articles';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setSubmitStatus('success');
      setEmail('');
      setTimeout(() => setSubmitStatus('idle'), 3000);
      return;
    }
    try {
      const payload = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'phone_alt' && value) {
          payload.append(key, value.toString());
        }
      });
      const response = await fetch('http://blw51.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch (_) { /* ignore parse error */ }
      if (response.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        setEmail('');
        setTimeout(() => setSubmitStatus('idle'), 3000);
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '';
        if (serverMsg.toLowerCase().includes('spam')) {
          setFormError('提交失败，请稍后再试');
        } else {
          setFormError(serverMsg || '订阅失败，请稍后再试');
        }
        setSubmitStatus('error');
        setTimeout(() => { setSubmitStatus('idle'); setFormError(''); }, 3000);
      }
    } catch (_err) {
      setFormError('网络错误，请检查网络后重试');
      setSubmitStatus('error');
      setTimeout(() => { setSubmitStatus('idle'); setFormError(''); }, 3000);
    }
  };

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="px-4 md:px-6 lg:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div>
            <Link to="/" className="text-xl font-bold text-background-50 no-underline">
              51爆料网
            </Link>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">
              实时追踪网红黑料与吃瓜爆料的专业平台
              <br />
              每日更新 · 黑料不打烊
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-colors" aria-label="抖音">
                <i className="ri-tiktok-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门栏目</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.hotCategories.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-background-300 hover:text-accent-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-background-300 hover:text-accent-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">订阅推送</h4>
            <p className="text-sm text-background-300 mb-3">第一时间获取最新爆料，精彩不容错过</p>
            <form
             
              onSubmit={handleSubscribe}
              className="flex flex-col gap-2"
            >
              <div className="honeypot-field">
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
              </div>
              <div className="flex">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱地址"
                  required
                  className="flex-1 px-3 py-2.5 text-sm bg-background-800 border border-background-700 rounded-l-lg text-background-100 placeholder:text-background-500 focus:outline-none focus:border-accent-500 transition-colors"
                />
                <button
                  type="submit"
                  disabled={submitStatus === 'success'}
                  className="px-4 py-2.5 bg-accent-500 text-background-50 rounded-r-lg hover:bg-accent-600 transition-colors disabled:opacity-50 whitespace-nowrap"
                >
                  <i className="ri-send-plane-line text-sm w-4 h-4 flex items-center justify-center"></i>
                </button>
              </div>
              {submitStatus === 'success' && (
                <p className="text-xs text-green-400">订阅成功！感谢关注</p>
              )}
              {submitStatus === 'error' && formError && (
                <p className="text-xs text-red-400">{formError}</p>
              )}
            </form>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800/70">
        <div className="px-4 md:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2026 51爆料网 版权所有
          </p>
          <p className="text-xs text-background-500">
            本网站内容仅供娱乐参考，不构成任何投资或法律建议
          </p>
        </div>
      </div>

      <div className="pb-8 px-4 text-center overflow-hidden">
        <span className="text-6xl md:text-8xl font-black text-background-800/20 select-none whitespace-nowrap">
          51爆料网
        </span>
      </div>
    </footer>
  );
}